<div class="d-flex flex-column w-100 df-superheader">
  <header class="navbar navbar-dark bg-dark-primary navbar-expand-lg flex-shrink-0">
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarText"
      aria-controls="navbarText"
      [attr.aria-expanded]="!navbarCollapsed"
      aria-label="Toggle navigation"
      (click)="navbarCollapsed = !navbarCollapsed"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <a class="navbar-brand">
      <df-amadeus-logo svgClass="df-logo-dim" />
      <span id="page-title" class="text-white ms-3">App Store</span>
    </a>
    <div class="flex-grow-1"></div>
    <ama-ng-preferences></ama-ng-preferences>

    <nav [ngbCollapse]="navbarCollapsed" class="collapse navbar-collapse d-lg-none d-xl-none" id="navbarText">
      <ama-ng-navbar
           [numberNewApps]="numberNewApps"
           [section]="section"
           idSuffix="-hb"
           (menuItemSelected)="navbarCollapsed = true"></ama-ng-navbar>
    </nav>
  </header>

  <nav class="navbar navbar-light navbar-expand-lg">
    <ama-ng-navbar class="collapse navbar-collapse"
         [numberNewApps]="numberNewApps"
         [section]="section"
         idSuffix="">
    </ama-ng-navbar>
  </nav>
</div>
